import { ROUTES } from "@/constants/routes";

export type WatchlistItemPathname = `${typeof ROUTES.WATCHLIST}/${string}`;

/** Extract watch id from a `/watchlist/:watchId` pathname. */
export function getWatchIdFromWatchlistItemPathname(
	pathname: string,
): string | undefined {
	if (!isWatchlistItemPathname(pathname)) return undefined;
	return pathname.slice(`${ROUTES.WATCHLIST}/`.length);
}

/** True when pathname is `/watchlist/:watchId` (not the create route). */
export function isWatchlistItemPathname(
	value: unknown,
): value is WatchlistItemPathname {
	if (typeof value !== "string") return false;
	if (!value.startsWith(`${ROUTES.WATCHLIST}/`)) return false;
	if (value === ROUTES.WATCHLIST_CREATE) return false;

	const watchId = value.slice(`${ROUTES.WATCHLIST}/`.length);
	return watchId.length > 0 && !watchId.includes("/");
}
